import { useQuery } from '@tanstack/react-query';
import { signalsClient } from '@terra/shared-rest-clients-signals';
import type { SignalSourceFilterOptions } from '@terra/shared-contracts-signals';

export const SIGNAL_SOURCE_FILTER_OPTIONS_QUERY_KEY =
  'signalSourceFilterOptions';

export const useSignalSourceFilterOptions = ({
  applicationId,
  enabled = true,
}: {
  applicationId?: string;
  enabled?: boolean;
}) => {
  const { data, isLoading, error } = useQuery<SignalSourceFilterOptions>({
    queryKey: [SIGNAL_SOURCE_FILTER_OPTIONS_QUERY_KEY, applicationId],
    queryFn: async () => {
      if (!applicationId) {
        throw new Error(
          'useSignalSourceFilterOptions: applicationId is required',
        );
      }
      const response = await signalsClient.getSignalSourceFilterOptions({
        params: { applicationId },
      });
      if (response.status !== 200) {
        throw new Error('Failed to fetch signal source filter options');
      }
      return response.body as SignalSourceFilterOptions;
    },
    enabled: !!applicationId && enabled,
  });

  return {
    hasThirdPartySignals: data?.hasThirdPartySignals,
    isLoading,
    error,
  };
};
